export enum AppMenuTab {
    DropdownLogo = 'dropdown_logo',
    Dashboards = 'dashboards',
    DataSources = 'data_sources',
    Data = 'data',
    Transformers = 'transformers',
    Exports = 'exports',
    Reports = 'reports',
    None = ''
}
